import store from '../store';

function decorateName(name) {
  if (name.toLowerCase() === 'inbox') {
    return 'a' + name;
  } else if (name === store.state.specialFolders['\\Sent']) {
    return 'b' + name;
  } else if (name === store.state.specialFolders['\\Trash']) {
    return 'c' + name;
  }
  return 'z' + name;
}

export default function(children, root = false) {
  let names = Object.keys(children);

  if (root) {
    names = names.sort((a, b) => {
      return decorateName(a).toLowerCase().localeCompare(decorateName(b).toLowerCase());
    });
  } else {
    names = names.sort((a, b) => {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
  }
  return names;
}
